<div class="flex items-center justify-center">
    <div class="loader" [ngClass]="spinColor"></div>
</div>
